import * as React from "react";
import { Modal, Form, Button } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { Moment } from "moment";
import { ThunkDispatch } from "redux-thunk";

import { Action } from "redux";

import { connect } from "react-redux";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { FileAnswer } from "@teamprevent/common/questionnaires/model";

import { ApplicationState } from "../../../applicationState";

import { ACTION_TASK } from "../../../crud/ohCase/actiontypes";
import { ChaseImmunisationBloodTestResultsTask } from "../../taskTypes";
import { addBloodTestResult } from "../../../immunisationOhCase/actions";

import { actionTask } from "../../../crud/ohCase/actions";
import { CreateImmunisationTaskDto } from "../../model";
import { ADD_BLOOD_TEST_RESULT } from "../../../immunisationOhCase/actionTypes";

import { ImmunisationBloodTestResultForm } from "./ImmunisationBloodTestResultForm";
import { ChaseImmunisationBloodTestResultForm } from "./ChaseImmunisationBloodTestResultForm";

const chaseOption = "Chase again";
const resultsOption = "Results";
type FollowUpTask = typeof chaseOption | typeof resultsOption;

interface Props {
    task: TaskModel;
    onClose: () => void;
    submitChaseBloodTestResultForm: (dueDate: Moment, notes: string, task: TaskModel) => Promise<void>;
    submitBloodTestResultForm: (result: string, evidence: FileAnswer, task: TaskModel) => Promise<void>;
}

const ChaseImmunisationBloodTestResultModalUnconnected: React.FunctionComponent<Props> = ({ onClose, ...props }) => {

    const [followUpTask, setFollowUpTask] = React.useState<FollowUpTask | null>(null);
    const chaseForm = React.useRef<ChaseImmunisationBloodTestResultForm>(null);
    const resultsForm = React.useRef<ImmunisationBloodTestResultForm>(null);
    const onFollowUpTaskChanged = React.useCallback((task: FollowUpTask) => setFollowUpTask(task), []);

    const onSubmit = React.useCallback(async () => {
        switch (followUpTask) {
            case "Chase again":
                await chaseForm.current?.submit();
                onClose();
                return;
            case "Results":
                const success = await resultsForm.current?.submit();
                if (success) {
                    onClose();
                }
                return;
            default:
                return;
        }
    }, [followUpTask, onClose]);

    return (
        <Modal open>
            <Modal.Header>Chase Blood Test Result</Modal.Header>
            <Modal.Content>
                <Form>
                    <Input.Dropdown
                        label="Follow-up task"
                        options={[chaseOption, resultsOption].map(t => ({ text: t, value: t }))}
                        value={followUpTask}
                        onChange={onFollowUpTaskChanged}
                    />
                    {followUpTask === chaseOption &&
                        <ChaseImmunisationBloodTestResultForm ref={chaseForm} submit={props.submitChaseBloodTestResultForm} task={props.task} />}
                    {followUpTask === resultsOption &&
                        <ImmunisationBloodTestResultForm ref={resultsForm} submit={props.submitBloodTestResultForm} task={props.task} />}
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={onClose} />
                {followUpTask && <IsLoadingButton requestNames={[ACTION_TASK, ADD_BLOOD_TEST_RESULT]} content="Submit" onClick={onSubmit} />}
            </Modal.Actions>
        </Modal>
    );
};

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, void, Action>) => {
    return {
        submitChaseBloodTestResultForm: async (dueDate: Moment, notes: string, task: TaskModel) => {
            const followUpTask: CreateImmunisationTaskDto = {
                caseId: task.caseId,
                localDueDate: dueDate.toDate(),
                taskCodeId: null,
                notes: null,
                precedingTaskId: task.id,
                taskType: ChaseImmunisationBloodTestResultsTask.type,
                immunisationTypeTasks: null,
                ...ChaseImmunisationBloodTestResultsTask
            };
            await dispatch(actionTask(task.customer.id, task.caseId, task.id, notes, followUpTask));
        },
        submitBloodTestResultForm: async (result: string, evidence: FileAnswer, task: TaskModel) => {
            await dispatch(addBloodTestResult(task.customer.id, task.employeeRecord.id, task.caseId, task.id, result, evidence));
        }
    };
};

export const ChaseImmunisationBloodTestResultModal = connect(null, mapDispatchToProps)(ChaseImmunisationBloodTestResultModalUnconnected);
